import FileUpload from '@/components/upload/upload';
import { Button, useSnackbar } from '@rrexpress/core';
import React, { useState } from 'react';

const ImportOrder: React.FC<{ onUpload: (v: any) => void }> = (props) => {
  const [file, setFile] = useState([]);
  const { show } = useSnackbar();

  const handleDownloadTemplate = async () => {
    try {
      const response = await fetch(`${window.location.origin}/tpl/template-import-order.xlsx`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'template-import-order.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      show('Gagal download template', 'error');
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-1 bg-white">
      <div className="text-2xl font-bold text-gray-800 mb-2">Import order</div>
      <div className="text-gray-600 mb-8">
        Ikuti beberapa langkah di bawah ini untuk melakukan impor order.
      </div>

      <div className="space-y-5 max-h-[400px] overflow-y-auto p-5">
        {/* Step 1 */}
        <div className="flex items-start space-x-4 rounded-lg border p-8">
          <div className="text-lg font-bold text-blue-600">1.</div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800">Download file template</h3>
            <p className="text-gray-600 mt-2">
              {'Pakai template ini untuk menyesuaikan impor data rute dengan format yang telah ditentukan.'}
            </p>
            <div className="mt-5">
              <Button
                onClick={() => handleDownloadTemplate()}
              >
                Download Template
              </Button>
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex items-start space-x-4 rounded-lg border p-8">
          <div className="text-lg font-bold text-blue-600">2.</div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800">Sesuaikan isi template</h3>
            <p className="text-gray-600 mt-2">
              {'Ubah template dengan mengisinya dari salinan data yang telah kamu miliki menggunakan aplikasi edit dengan format file Excel. Lalu, isi sesuai dengan kolom yang tepat.'}
            </p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="flex items-start space-x-4 rounded-lg border p-8">
          <div className="text-lg font-bold text-blue-600">3.</div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800">Upload file template</h3>
            <p className="text-gray-600 mt-2">
              {'Upload kembali file yang sudah disesuaikan dengan datamu. Pastikan file berformat .xlsx sehingga kami dapat memprosesnya.'}
            </p>
            <div className="mt-4 p-6 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 text-center">
              <FileUpload onChangeFile={setFile} />
            </div>
          </div>
        </div>
      </div>

      <div className="text-right mt-5">
        <Button
          type="button"
          onClick={() => props?.onUpload(file)}
        >
          Upload
        </Button>
      </div>
    </div>

  );
};

export default ImportOrder;
